import BaseService from './BaseService';

class GeneralService extends BaseService {
    getCountryListOptions = () => this.get('/get-country-list');

    getCompanyListOptions = () => this.get('/get-company-list');
}

export default new GeneralService();
